import './css/normalize.css'
import './css/main.css'
import './util/web-animations.min.js'
import Timeline from './util/Timeline.js'

if (location.pathname === '/') {
  const lang = window.navigator.userLanguage || window.navigator.language
  if (!localStorage.getItem('language')) {
    localStorage.setItem('language', lang.startsWith('zh') ? 'zh' : 'en')
    let redirectUrl
    if (lang.startsWith('zh')) {
      window.localStorage.setItem('language', 'zh')
      redirectUrl = `${location.origin}/zh/index.html`
    } else {
      window.localStorage.setItem('language', 'en')
      redirectUrl = `${location.origin}`
    }
    location.replace(redirectUrl)
  } else {
    if (localStorage.getItem('language') === 'zh') {
      window.localStorage.setItem('language', 'zh')
      location.replace(`${location.origin}/zh/index.html`)
    } else {
      window.localStorage.setItem('language', 'en')
      location.replace(`${location.origin}/index.html`)
    }
  }
}
if (document.getElementById('lan-selector')) {
  document.getElementById('lan-selector').addEventListener('change', (e) => {
    const lang = e.target.value
    let currentPath
    let redirectUrl
    if (lang === 'zh') {
      window.localStorage.setItem('language', 'zh')
      currentPath = location.pathname === '/' ? '/index.html' : location.pathname
      redirectUrl = `${location.origin}/zh${currentPath}`
    } else {
      window.localStorage.setItem('language', 'en')
      currentPath = location.pathname === '/' ? '/index.html' : location.pathname.replace(/\/zh/g, '')
      redirectUrl = `${location.origin}${currentPath}`
    }
    location.replace(redirectUrl)
  })
}

var openSidebar = function () {
  document.getElementsByClassName('menu-body')[0].classList.add('is-active')
}

var closeSidebar = function () {
  document.getElementsByClassName('menu-body')[0].classList.remove('is-active')
}

const breadcrumb = document.getElementById('btn')
if (breadcrumb) {
  breadcrumb.addEventListener('click', function () {
    if (this.className.includes('on')) {
      closeSidebar()
      this.classList.remove('on')
      document.body.style.overflowY = 'auto'
    } else {
      openSidebar()
      this.classList.add('on')
      document.body.style.overflowY = 'hidden'
    }
  })
}

var timeline = document.getElementById('Timeline')

// listen for scroll event and call animate function
if (timeline) {
  document.addEventListener('scroll', function scrollListener () {
    if (inView(timeline)) {
      Timeline.createAllAnimations()
      document.removeEventListener('scroll', scrollListener)
    }
  })
}

// check if element is in view
function inView (element) {
  var elementHeight = element.clientHeight
  // get window height
  var windowHeight = window.innerHeight
  // get number of pixels that the document is scrolled
  var scrollY = window.scrollY || window.pageYOffset
  
  // get current scroll position (distance from the top of the page to the bottom of the current viewport)
  var scrollPosition = scrollY + windowHeight
  // get element position (distance from the top of the page to the bottom of the element)
  var elementPosition = element.getBoundingClientRect().top + scrollY + elementHeight
  
  // is scroll position greater than element position? (is element in view?)
  if (scrollPosition > elementPosition) {
    return true
  }
  return false
}
